import { selectEtazhiBlackFridayDiscountByOfferId } from './selectEtazhiBlackFridayDiscountByOfferId';
import { selectEtazhiBlackFridayPromoOffersData } from './selectEtazhiBlackFridayPromoOffersData';

import type { IAppState } from 'shared/common/state';
import type { IEtazhiBlackFridayLabel } from 'shared/types/etazhiBlackFriday';

/**
 * Вернёт конфигурацию для лейбла скидки оффера: цвет и текст.
 */
export const selectEtazhiBlackFridayOfferLabelData =
  (offerId: number, offerPriceRur: number) =>
  (state: IAppState): IEtazhiBlackFridayLabel | null => {
    const promoOffersData = selectEtazhiBlackFridayPromoOffersData(state);

    if (!promoOffersData?.label) {
      return null;
    }

    const discount = selectEtazhiBlackFridayDiscountByOfferId(offerId, offerPriceRur)(state);

    if (!discount) {
      return null;
    }

    return promoOffersData.label;
  };
